import React from "react"
import { useSelector } from "react-redux"
import ApplicationContainer from "components/ApplicationContainer"
import Drawer from "components/Drawer"
import AppBar from "components/AppBar"
import * as practiceSelectors from "app/redux/practice/practice.selectors"
import { useLocation } from "react-router-dom"
import UserBar from "../UserBar"
import PracticeBar from "../PracticeBar"
import { AppMain } from "../style"
import { useNavigationItems } from "./hooks"

const DefaultLayoutDesktop = ({
  appUtilityBar: AppUtilityBar,
  children,
}: {
  children: React.ReactNode
  appUtilityBar: React.ElementType
}) => {
  const practice = useSelector(practiceSelectors.getPractice)
  const navigationItems = useNavigationItems("desktop")
  const { pathname: path } = useLocation()
  const tabId = path.split("/").pop()
  const practiceFeatures = practice?.features
  const nonFlaggedNavigationItems = navigationItems.filter(({ featureFlag }) => {
    if (featureFlag) return practiceFeatures?.[featureFlag]
    return true
  })
  return (
    <ApplicationContainer>
      <Drawer navigationItems={nonFlaggedNavigationItems} />
      <AppMain>
        <AppBar leftComponent={<PracticeBar practice={practice!} />} rightComponent={<UserBar />} />
        <AppUtilityBar id={tabId} />
        {children}
      </AppMain>
    </ApplicationContainer>
  )
}

export default DefaultLayoutDesktop
